import { SVGProps } from 'react';

export const FollowUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.03516 8.59995L11.6696 11.2343L9.03516 13.8687L10.1664 14.9999L13.932 11.2343L10.1664 7.46875L9.03516 8.59995Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.4 0.835938H1.6C0.7176 0.835938 0 1.55354 0 2.43594V10.4359C0 11.3183 0.7176 12.0359 1.6 12.0359H6.8688L5.0344 13.8703L6.1656 15.0015L9.9312 11.2359L6.1656 7.47034L5.0344 8.60154L6.8688 10.4359H1.6V2.43594H14.4V5.63594H16V2.43594C16 1.55354 15.2824 0.835938 14.4 0.835938"
      fill="currentColor"
    />
  </svg>
);
